import { Box, InputLabel, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import { TOTAL_INCOME_STRUCTURE_ID } from 'src/Enum/IncomeStructure';
import { useIncomeStructure } from '../IncomeStructureProvider/IncomeStructureProvider';
import { findMasterDataById } from '../utils';
import ProductIncomeYearFieldsPct from './ProductIncomeYearFieldsPct';

const ProductIncomeTotalPct = () => {
  const { productIncome } = useIncomeStructure();

  const totalProductIncomePct = findMasterDataById(
    productIncome,
    TOTAL_INCOME_STRUCTURE_ID.TOTAL_PRODUCT_INCOME
  );

  return (
    <>
      {totalProductIncomePct && (
        <Flex width={1} mt={2} alignItems={'center'}>
          <Box width={1} minWidth={235} maxWidth={350}>
            <InputLabel sx={{ textAlign: 'right', fontWeight: 800 }}>
              {totalProductIncomePct.nameTh}
            </InputLabel>
            <Typography textAlign={'right'} color={'text.secondary'}>
              (%)
            </Typography>
          </Box>
          <ProductIncomeYearFieldsPct
            keyItem={totalProductIncomePct.id.toString()}
          />
        </Flex>
      )}
    </>
  );
};

export default ProductIncomeTotalPct;
